<template>
  <BadgeIcon v-if="showChangeIcon(keyList)" class="-sm -changed _ml-10">
    変更あり
  </BadgeIcon>
</template>

<script>
import BadgeIcon from "@/components/badges/BadgeIcon";

export default {
  name: "ChangeBadgeIcon",
  components: { BadgeIcon },
  props: {
    keyList: { type: Array, default: () => [] },
    diffKeys: { type: Array, default: () => [] },
  },
  methods: {
    showChangeIcon(keyList) {
      if (keyList && keyList.length > 0) {
        for (let key of keyList) {
          if (this.diffKeys.indexOf(key) > -1) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
